import { render } from "./nav-points.vue?vue&type=template&id=0cea3e56&scoped=true&ts=true"
import script from "./nav-points.vue?vue&type=script&lang=ts"
export * from "./nav-points.vue?vue&type=script&lang=ts"

import "./nav-points.vue?vue&type=style&index=0&id=0cea3e56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cea3e56"]])

export default __exports__